import { EpicIcons } from "@constellation-academy/epic-ui";
import { confirmDialog } from "primereact/confirmdialog";
import { useMutation } from "react-relay";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { resetPasswordButton_TriggerResetPasswordMutation } from "@relay/resetPasswordButton_TriggerResetPasswordMutation.graphql";
import { TRIGGER_RESET_PASSWORD_MUTATION } from "./reset-password-button.graphql";
import { ResetPasswordButtonProps } from "./reset-password-button.types";
import { Button } from "../../../../components/button";

export const ResetPasswordButton = ({ userId }: ResetPasswordButtonProps) => {
	const { t } = useTranslation("common");
	const [triggerResetPassword, isResettingPassword] =
		useMutation<resetPasswordButton_TriggerResetPasswordMutation>(
			TRIGGER_RESET_PASSWORD_MUTATION,
		);

	const handleOnResetPasswordClick = () => {
		confirmDialog({
			header: t("userEdit.resetPassword"),
			message: t("userEdit.resetPasswordConfirmMessage"),
			icon: "pi pi-info-circle",
			acceptClassName: "p-button-danger",
			acceptLabel: t("actions.yes"),
			rejectLabel: t("actions.no"),
			accept: () =>
				triggerResetPassword({
					variables: {
						input: {
							userId,
						},
					},
					onCompleted: () => {
						toast.success(t("userEdit.passwordResetSuccess"));
					},
				}),
		});
	};

	return (
		<>
			<Button
				icon={EpicIcons.KEY}
				label={t("userEdit.resetPassword")}
				onClick={handleOnResetPasswordClick}
				disabled={isResettingPassword}
			/>
		</>
	);
};
